<div class="tab-pane fade show active details-view-results"
     (dragover)="onDragOver($event)"
     (dragleave)="onDragLeave($event)"
     (drop)="onDrop($event)"
     [class.drag-over]="dragOver">

  <div *ngIf="isUploading" class="upload-overlay">
    <div class="spinner-border text-primary" role="status">
    </div>
  </div>

  <div class="details-view-results-head">
    <div class="row">
      <div class="col-6">
        <form [formGroup]="filterForm">
          <app-dropdown-input (selectValueChanged)="onFilterChange($event)" name="order" [parentForm]="filterForm" [options]="orderingOptions" selectedValue="newest" className="slim md"></app-dropdown-input>
        </form>
      </div>
      <div class="col-6 text-right">
        <a (click)="onOpenFileBrowser($event)" class="btn btn-outline btn-slim btn-add-ticket" *ngIf="_authService.hasPermission(Permissions.PatientDocumentsWrite)">+ Add Document(s)</a>
        <div style="height: 50px;" *ngIf="!_authService.hasPermission(Permissions.PatientDocumentsWrite)"><!-- Spacer --></div>
        <input #fileUploadInput type="file" id="file-upload-input" style="display: none" multiple
               (change)="onFileSelected($event)"
               accept=".pdf,.jpg,.jpeg,.png,.gif,.bmp,.webp" />
      </div>
    </div>
  </div>

  <div *ngIf="documents.length === 0 && _authService.hasPermission(Permissions.PatientDocumentsWrite)" class="empty-documents-message">
    <div class="text-center p-4 text-muted">
      <i class="far fa-upload fa-2x mb-2"></i>
      <div>Drop files here to upload or click <b>Add Document(s)</b> above.</div>
    </div>
  </div>

  <div *ngIf="documents.length === 0 && !_authService.hasPermission(Permissions.PatientDocumentsWrite)" class="empty-documents-message">
    <div class="text-center p-4 text-muted">
      <i class="far fa-upload fa-2x mb-2"></i>
      <div>Patient has no documents.</div>
    </div>
  </div>

  <ul *ngIf="documents.length > 0" class="documents">
    <ng-container *ngFor="let document of documents; let i = index">
      <li [class.deleting]="document.id === removingDocumentId">
        <a>{{ document.originalFileName }}</a>

        <div class="buttons">
          <span>{{ document.created | date:'d MMM y h:mma'}}</span>
          <app-button text="Remove" type="button" size="sm" (click)="confirmationModal.showConfirmation(document.id)" *ngIf="_authService.hasPermission(Permissions.PatientDocumentsWrite)"></app-button>
          <div style="width: 100px">
            <app-button width="fill" [text]="canPreviewDocument(document.originalFileName) ? 'View' : 'Download'" type="button" variant="info" size="sm" (click)="onViewDocument(document.id)"></app-button>
          </div>
        </div>
      </li>
    </ng-container>
  </ul>

</div>

<app-confirm-action-modal #confirmationModal (confirmed)="onRemoveDocumentConfirmed($event)" title="Remove Document?" message="Are you sure you want to remove this document?" cancelBtnText="No"  />

<app-document-viewer-modal #documentViewer></app-document-viewer-modal>
